module.exports = __webpack_public_path__ + "img/round-icon-bg.4eb95e10.svg";